module.exports = __webpack_public_path__ + "static/img/weather_011.52693407.svg";